var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccountCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5V5.5C18 6.60457 17.1046 7.5 16 7.5H8C6.89543 7.5 6 6.60457 6 5.5V5H5.5C4.67157 5 4 5.67157 4 6.5V18.5C4 19.3284 4.67157 20 5.5 20H18.5C19.3284 20 20 19.3284 20 18.5V6.5C20 5.67157 19.3284 5 18.5 5H18ZM11.5802 3.09214C11.2376 3.25082 11 3.59766 11 4C11 4.55228 11.4477 5 12 5C12.5523 5 13 4.55228 13 4C13 3.59766 12.7624 3.25082 12.4198 3.09214C12.2918 3.03291 12.1494 3 12 3C11.8506 3 11.7082 3.03291 11.5802 3.09214ZM5.5 3H9.17071C9.58254 1.83481 10.6938 1 12 1C13.3062 1 14.4175 1.83481 14.8293 3H18.5C20.433 3 22 4.567 22 6.5V18.5C22 20.433 20.433 22 18.5 22H5.5C3.567 22 2 20.433 2 18.5V6.5C2 4.567 3.567 3 5.5 3ZM12 13.5C13.2407 13.5 14.25 12.4907 14.25 11.25C14.25 10.0093 13.2407 9 12 9C10.7593 9 9.75 10.0093 9.75 11.25C9.75 12.4907 10.7593 13.5 12 13.5ZM12 14.3824C10.2009 14.3824 7.5 14.9706 7.5 16.4412V16.7353C7.5 17.7099 8.05323 18.5 9 18.5H15C15.9468 18.5 16.5 17.7099 16.5 16.7353V16.4412C16.5 14.9706 13.7991 14.3824 12 14.3824Z",
    fill: "#121922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountCard);
export default __webpack_public_path__ + "static/media/iconAccountCard.2c8bf7c6027108691bbea74aac92871b.svg";
export { ForwardRef as ReactComponent };